module.exports = __webpack_public_path__ + "static/img/bg_soldoc_partners_effect.cf41ffd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners_pc/bg_soldoc_partners_effect.png
// module id = gP+Q
// module chunks = 1